import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { OnboardingLS } from '../../../../util/local_storage/onboarding.ls';
import Icon, { IconType } from '../../../icons/Icon';
import OnboardingAbortModal from '../modals/OnboardingAbortModal';

interface OnboardingPaneHeaderProps {
  back?: () => void;
}

export default function OnboardingPaneHeader({ back }: OnboardingPaneHeaderProps) {
  const navigate = useNavigate();

  const [abortModalOpen, setAbortModalOpen] = useState(false);

  return (
    <>
      {abortModalOpen && (
        <OnboardingAbortModal
          open={abortModalOpen}
          setOpen={setAbortModalOpen}
          onAbort={() => {
            OnboardingLS.removeOnboardingData();
            navigate('/company');
          }}
        />
      )}

      <div className={`flex ${back ? 'justify-between' : ' justify-end'} stroke-gray-400`}>
        {back && <Icon type={IconType.arrowNarrowLeft} onClick={back} className='my-3' />}
        <Icon type={IconType.xClose} onClick={() => setAbortModalOpen(true)} className='my-3' />
      </div>
    </>
  );
}
